import { getTheme } from '@hdi-seguros/web-components.theme-config-provider';

import { COLORS } from './colors';

/*
 * Aquí podemos configurar los estilos de los componentes que utilicemos de AntDesign.
 */

const themeC = getTheme();

themeC.components!.Alert = {
  ...themeC.components!.Alert,
  colorWarning: COLORS.accents.yellow_ochre[100],
  colorWarningBg: COLORS.accents.yellow_ochre[30],
};

themeC.token!.colorTextPlaceholder = COLORS.neutrals[50];
themeC.token!.colorTextQuaternary = COLORS.neutrals[50];

// !! ESTO SE AGREGÓ PORQUE EN EL PROYECTO DE COMPONENTES ME ESTÁ MODIFICANDO EL COLOR, HABRÍA QUE BORRAR LA CONFIGURACIÓN DEL INPUT DESDE EL COMPONENTE.
themeC.components!.Input = {
  ...themeC.components!.Input,
  colorTextPlaceholder: COLORS.neutrals[50],
};

export const theme = { ...themeC };
